<div
  class="dropdown-container"
  [ngClass]="{
    open: isOpen,
    active: isActive,
    small: size === 'small',
    dark: colorTheme === 'dark'
  }"
  >
  <div class="dropdown-header" (click)="toggleDropdown()">
    <a routerLinkActive="active">
      @if (icon) {
        <app-svg-icon [name]="icon"></app-svg-icon>
      }

      {{ title }}</a
      >

      <mat-icon>{{
        isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
      }}</mat-icon>
    </div>
    <div class="dropdown-menu">
      @for (item of items; track item) {
        <div
          class="dropdown-item"
          (click)="navigateTo(item.route)"
          >
          {{ item.label | translate }}
        </div>
      }
    </div>
  </div>
